import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import moment from 'moment';
import 'moment-timezone';

const Heading = styled.th`
text-align: center;
`

const TableBody = styled.tbody`
    line-height:0.25
`

const TimeCell = styled.th`
  border-top: none !important;
  text-align: right;
  width: 65px;
`

const TimeText= styled.div`
    position: relative;
    top: -14px;
`

const TopLeft = styled.th`
  border-bottom: none !important;
`

const RoomBookingStart = styled.td`
  background-color:${props => props.backgroundColour};
  border-width: 2px 2px 0 2px;
  border-style: inset;
`
const RoomBooking = styled.td`
  background-color:${props => props.backgroundColour};
  border-top: none !important;
  border-width: 0 2px;
  border-style: inset;
`

const RoomBookingEnd = styled.td`
  background-color:${props => props.backgroundColour};
  border-top: none !important;
  border-width: 0 2px 2px 2px;
  border-style: inset;
`

class TimetableContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    events: this.props.events,
    day: this.props.day
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
        this.setState(this.props);
    }
  }

  createTableBody = () => {
    let tableBody = [];
    let startTime = moment(this.state.day).add(10,'h');
    let endTime = moment(startTime).add(30,'m');
    
    //let backgroundColour = ['#a2b8ec','#B0E57C','#FFAEAE','#FFEC94','#B4D8E7'];
    //let backgroundColour = ['#95afee','#9CCF31','#CE0000','#F7D708','#009ECE'];
    let backgroundColour = ['#4c6090','#4c6090','#4c6090','#4c6090','#4c6090'];
    //let backgroundColour = ['#4c6090','#4b7820','#a33b3b','#f0d553','#74b2ca'];

    for (let i = 0; i < 26; i++) {
        let cells = [<TimeCell key={i} scope="row"><TimeText>{startTime.format('HH.mm').toString()}</TimeText></TimeCell>];
        for (let j = 1; j <=5; j++) {
            let bookings = this.state.events.filter(e => e.room === j)[0].bookings;
            let formatted = false;
            for (let index = 0; index <= bookings.length-1; index++) {
                if (bookings[index].start.isSame(startTime)) {
                    cells.push(<RoomBookingStart key={"col" + i + "row"+j} backgroundColour={backgroundColour[j-1]} ></RoomBookingStart>);
                    formatted = true;
                    break;
                }
                else if (bookings[index].start.isBefore(startTime) && bookings[index].end.isAfter(endTime)) {
                    cells.push(<RoomBooking key={"col" + i + "row"+j} backgroundColour={backgroundColour[j-1]} ></RoomBooking>);
                    formatted = true;
                    break;
                }
                else if (bookings[index].end.isSame(endTime)) {
                    cells.push(<RoomBookingEnd key={"col" + i + "row"+j} backgroundColour={backgroundColour[j-1]} ></RoomBookingEnd>);
                    formatted = true;
                    break;
                };
            };
            if (formatted === false) {
                cells.push(<td key={"col" + i + "row"+j}  ></td>);
            }
        }

        tableBody.push(<tr key={"row"+i} >{cells}</tr>);
           
        startTime = moment(startTime.add(30, 'm'));
        endTime = moment(startTime).add(30,'m');
    }

    tableBody.push(<tr key={"row27"} >
      <TimeCell scope="row"><TimeText>{startTime.format('HH.mm').toString()}</TimeText></TimeCell>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      </tr>);

    return tableBody
  }



  render () {
    return (
        <table className="table">
          <thead>
            <tr>
              <TopLeft scope="col"></TopLeft>
              <Heading scope="col">Room 1</Heading>
              <Heading scope="col">Room 2</Heading>
              <Heading scope="col">Room 3</Heading>
              <Heading scope="col">Room 4</Heading>
              <Heading scope="col">Room 5</Heading>
            </tr>
          </thead>
          <TableBody>
          {this.createTableBody()}
          </TableBody>
        </table>
    )
  }
}

export default TimetableContainer;


// WEBPACK FOOTER //
// ./src/roomTimetable/TimetableContainer.js